export function getPaginationNumbers(page, totalPages, isMobile) {
  const maxNumbers = isMobile ? 3 : 5;
  if (totalPages <= maxNumbers) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  let pages = [];
  if (maxNumbers === 3) {
    // Mobile: only 3 numbers
    if (page <= 2) {
      pages = [1, 2, '...', totalPages];
    } else if (page >= totalPages - 1) {
      pages = [1, '...', totalPages - 1, totalPages];
    } else if (page === 3 && totalPages > 4) {
      pages = [1, 2, 3, 4, '...', totalPages];
    } else if (page === totalPages - 2 && totalPages > 4) {
      pages = [1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      pages = [1, '...', page - 1, page, page + 1, '...', totalPages];
    }
    pages = pages.filter(
      (v, i, arr) => arr.indexOf(v) === i && (v !== '...' || arr[i + 1] !== '...')
    );
    // Ensure max 3 numbers plus ellipsis
    let numCount = pages.filter((p) => typeof p === 'number').length;
    if (numCount > 3) {
      // This part is tricky for all cases, but a simplified logic might work
      // If more than 3 numbers, try to keep current, prev, next
      let nums = [];
      if (page > 1) nums.push(page - 1);
      nums.push(page);
      if (page < totalPages) nums.push(page + 1);
      pages = [1, '...', ...nums, '...', totalPages].filter(
        (v, i, arr) => arr.indexOf(v) === i && (v !== '...' || arr[i + 1] !== '...')
      );
    }
    return pages;
  } else {
    // Desktop: 5 numbers
    if (page <= 3) {
      pages = [1, 2, 3, 4, '...', totalPages];
    } else if (page >= totalPages - 2) {
      pages = [1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    } else {
      pages = [1, '...', page - 1, page, page + 1, '...', totalPages];
    }
    pages = pages.filter(
      (v, i, arr) => arr.indexOf(v) === i && (v !== '...' || arr[i + 1] !== '...')
    );
    // Ensure max 5 numbers plus ellipsis
    let numCount = pages.filter((p) => typeof p === 'number').length;
    if (numCount > 5) {
      // Similar simplification as mobile, keeping center pages
      let nums = [];
      for (let i = -2; i <= 2; i++) {
        if (page + i >= 1 && page + i <= totalPages) nums.push(page + i);
      }
      pages = [1, '...', ...nums, '...', totalPages].filter(
        (v, i, arr) => arr.indexOf(v) === i && (v !== '...' || arr[i + 1] !== '...')
      );
    }
    return pages;
  }
}

export function getGenderLabel(gender) {
  if (gender === 'male') return 'Boy';
  if (gender === 'female') return 'Girl';
  if (gender === '2' || gender === 'unisex') return 'Unisex';
  return gender;
}

export function getOrigin(n) {
  // You can adjust this if you have a real origin field
  return 'Assyrian';
}

export function generateNameList(names) {
  if (!Array.isArray(names) || names.length === 0) {
    return '<ul><li>No names available.</li></ul>';
  }

  let list = '<ul>';

  names.forEach((name) => {
    list += `
      <li>
        <strong>${name.eng_word}</strong> | 
        <span>${name.syr_word}</span> | 
        <span>${name.arb_word}</span> - 
        <em>${name.meaning}</em>
      </li>`;
  });

  list += '</ul>';

  return list;
}
